import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { fetchProducts, fetchCategories } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Seo } from "../components/Seo";

export default function Products() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [params, setParams] = useSearchParams();
  const active = params.get("category") || "all";

  useEffect(() => {
    fetchCategories().then(setCategories).catch(() => {});
  }, []);

  useEffect(() => {
    fetchProducts(active === "all" ? undefined : active).then(setProducts).catch(() => {});
  }, [active]);

  const setActive = (slug) => {
    if (slug === "all") setParams({});
    else setParams({ category: slug });
  };

  return (
    <div data-testid="products-page" className="max-w-[1360px] mx-auto px-6 lg:px-10 py-16">
      <Seo title="Buy Research Peptides UK — Full Catalogue" description="Shop the full Peptide Labs N.I. catalogue: BPC-157, NAD+, MOTS-c, Glutathione, Tesamorelin, Retatrutide and curated bundles. HPLC-verified, priced in GBP, UK dispatch." />
      <div className="max-w-3xl">
        <div className="label-mono">Catalog</div>
        <h1 className="mt-4 text-4xl lg:text-6xl tracking-tight text-white font-medium">
          Research Peptides.
        </h1>
        <p className="mt-4 text-[#B7BCC7] max-w-xl">
          Every lot HPLC-verified above 99% purity. Mass-spec confirmed. Endotoxin tested. Certificate of Analysis on request.
        </p>
      </div>

      <div className="mt-12 flex flex-wrap gap-2" data-testid="products-filter-bar">
        <button
          onClick={() => setActive("all")}
          data-testid="filter-all"
          className={`px-4 py-2 rounded-full text-sm border transition-colors ${
            active === "all"
              ? "bg-[#1565FF] text-white border-[#1565FF]"
              : "border-[#2A2A2A] text-[#B7BCC7] hover:border-[#1565FF] hover:text-white"
          }`}
        >
          All
        </button>
        {categories.map((c) => (
          <button
            key={c.slug}
            onClick={() => setActive(c.slug)}
            data-testid={`filter-${c.slug}`}
            className={`px-4 py-2 rounded-full text-sm border transition-colors ${
              active === c.slug
                ? "bg-[#1565FF] text-white border-[#1565FF]"
                : "border-[#2A2A2A] text-[#B7BCC7] hover:border-[#1565FF] hover:text-white"
            }`}
          >
            {c.name}
          </button>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {products.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>

      {products.length === 0 && (
        <div className="mt-16 text-[#6E7784] text-center">No products found in this category.</div>
      )}
    </div>
  );
}
